<template>
    <ButtonElement
        :href="href"
        :tag="tag"
        :modifier="modifier"
        :align="align"
        @click="$emit('click')"
    >
        <slot />
    </ButtonElement>
</template>
<script>

const ButtonElement =  {
    name: 'ButtonElement',
    functional: true,
    props: {
        tag: {
            type: String,
            default: null
        },
        modifier: {
            type: String,
            default: null
        },
        href: {
            type: String,
            default: null
        },
        align: {
            type: String,
            default: null
        }
    },
    render(createElement, {props, listeners, slots}) {
        return createElement(
            props.tag || 'a', {
                class: {
                    'BaseButton' : true,
                    'BaseButton--small' : props.modifier && props.modifier.includes('small'),
                    'BaseButton--medium' : props.modifier && props.modifier.includes('medium'),
                    'BaseButton--grey' : props.modifier && props.modifier.includes('grey'),
                    'BaseButton--white' : props.modifier && props.modifier.includes('white'),
                    'BaseButton--squared' : props.modifier && props.modifier.includes('squared'),
                    'is-icon-right' : props.align == 'right',
                    'is-icon-left' : props.align == 'left',
                    'BaseButton--ghost' : props.modifier && props.modifier.includes('ghost'),
                    'BaseButton--ghost-icon' : props.modifier && props.modifier.includes('ghost-icon'),
                },
                on: {
                    click: listeners.click
                },
                attrs: {
                    href: props.href
                },
            },
            slots().default
        );
    },
}

export default {
    name: 'BaseButton',
    components: {
        ButtonElement
    },
    props: {
        modifier: {
            type: String,
            default: null
        },
        align: {
            type: String,
            default: null
        },
        href: {
            type: String,
            default: null
        },
        tag: {
            type: String,
            default: 'a'
        }
    }
}
</script>
<style lang="scss">
    .BaseButton {
        display: inline-block;
        padding: 1rem getSpacing('large');
        background: $action-color;
        color: getColor('white');
        font-weight: 700;
        font-size: 0.7rem;
        border-radius: 2px;
        text-transform: uppercase;
        letter-spacing: 1px;
        text-align: center;
        transition: all ease-out 0.165s;
        line-height: 1.25;

        &:hover {
            background: getColor('blue', 'charcoal');
        }

        @include media-query(palm) {
            font-size: 0.75rem;
        }
    }

    .BaseButton--small {
        padding: 0.6rem 2.5rem;
        font-size: 0.6rem;
    }

    .BaseButton--medium {
        padding: 1rem 2rem;
    }

    .BaseButton--ghost {
        border: 1px solid currentColor;

        &:hover {
            background-color: getColor('white');
            color:$action-color;
        }
    }

    .BaseButton--ghost-icon {
        border: 1px solid currentColor;
        padding: 0.6rem;
        font-size: 0.6rem;
    }

    .BaseButton--grey {
        background: $border-color;
        color: $action-color;
        padding: 0.6rem 0.75rem;
        font-size: 12px;

        &:hover {
            color: getColor('white');
        }
    }

    .BaseButton--white {
        background: getColour('white');
        color: getColour('blue');
        padding: 0.6rem 0.75rem;
        font-size: 12px;

        &:hover {
            background: getColour('grey', 'light');
        }
    }

    .BaseButton--squared {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        width: 42px;
        height: 42px;
        font-size: 1.25rem;

        &.is-icon-left {
            justify-content: flex-start;
        }
        &.is-icon-right {
            justify-content: flex-end;
        }

        &.BaseButton--small {
            width: 30px;
            height: 30px;
        }
    }

    .BaseButton--mobile-stretch {
        @include media-query(smart) {
            display: block;
        }
    }
</style>
